import React from 'react'

interface Props{
    bgCarte?:string
    colorText?: string
    logo:string
    widthLogo?:string
    montantCarte:string
    ReceiveValueExcludingTax?: number
    ReceiveCurrency:string
    montantpayer:string
    index:number
    isSelected: boolean
    onSelect: (index: number) => void
    handleSelect: (index : any)=> void
    styleText?: string
}


const CarteRechargeMobile: React.FC<Props> = ({
    montantCarte, ReceiveCurrency, ReceiveValueExcludingTax, montantpayer, 
    index, isSelected, onSelect, handleSelect, logo, widthLogo, styleText
}) => {
 
   return (
    <div className={` 
        ${index===-1 ? 'text-[#767676] bg-[#EEEEEE]': isSelected ? 'bg-[#E2E2FB] text-[#35258B] ring-[#5754E5] ring-offset-4 ring-2  shadow-[0_0_15px_rgba(87,84,229,0.7)]': 'bg-[#EEEEEE]  opacity-35'}
    
    rounded-[20px] w-[320px] sm:w-full h-[132px]  shadow-sm cursor-pointer content-center flex flex-col justify-between px-[22px] py-[20px]`}

    onClick={()=>{ onSelect(index), handleSelect(index)}}
    >
        <div className='flex justify-between items-center w-full '>
            <div className='  font-roboto font-extrabold flex  items-start  '><span className={`${styleText ? styleText : 'text-[40px]'}  flex items-start leading-none `}> {montantCarte} </span><span className='text-[22px]  ml-1'>{ReceiveCurrency}</span></div>
            <img  className={widthLogo} src={logo} alt='carte operateur' />
        </div>
       
        <div  className={`flex w-full justify-between items-end font-inter leading-[12px] `}>
            <div className=' text-[10px] font-normal flex flex-col'>Montant reçu après taxe locale : <span className='font-bold text-[12px] mt-1'> {ReceiveValueExcludingTax} {ReceiveCurrency}</span></div>
            <div className=' font-normal text-[10px]'><h2>Montant à payer</h2> <div className='flex font-bold text-[12px] justify-end mt-1'>{montantpayer} €</div>
            </div>
        </div>
            
            

       
    </div>
  )
}

export default CarteRechargeMobile
